import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";
import { loginBg } from "../../utils/images";
import "./login.scss";
import "../../components/Button/button.scss";
import Back from "../../components/Button/Back";
import GlobalContext from "../../context/GlobalContext";

const Login = () => {
	const [loginUser, setLoginUser] = useState({
		email: "",
		password: "",
	});
	const {
		setIsLoading,
		isAuthenticated,
		setIsAuthenticated,
		updateUser,
		axiosInstance,
		setToken,
	} = useContext(GlobalContext);
	const navigate = useNavigate();
	const handleChange = (e) => {
		const { name, value } = e.target;
		setLoginUser((p) => ({
			...p,
			[name]: value,
		}));
	};
	const handleSubmit = async (e) => {
		e?.preventDefault();
		try {
			setIsLoading(true);
			const res = await axiosInstance.post("/api/auth/login", {
				...loginUser,
			});
			if (res.status === 200) {
				setToken(() => res.data.token);
				setIsAuthenticated(true);
				localStorage.setItem("token", res.data.token);
				localStorage.setItem("isAuthenticated", true);
				updateUser({ ...res.data.user });
				setIsLoading(false);
			}
		} catch (error) {
			alert(error?.response?.data?.message);
			setIsLoading(false);
		}
	};
	useEffect(() => {
		if (isAuthenticated) navigate("/admin");
	}, [isAuthenticated, navigate]);
	return (
		<main className="login">
			<aside
				className="login-side"
				style={{
					backgroundImage: `url(${loginBg})`,
				}}
				data-aos="fade-in"
			></aside>
			<Back />
			<section className="login-page">
				<div className="login-container">
					<h1>Welcome!</h1>
					<form onSubmit={handleSubmit}>
						<Input
							type="text"
							name="email"
							value={loginUser.email}
							onChange={handleChange}
							placeholder="Email"
							icon="mail"
						/>
						<Input
							type="password"
							name="password"
							value={loginUser.password}
							onChange={handleChange}
							placeholder="Password"
							icon="lock"
						/>
						<Button text="Login" type="submit" icon="login" />
					</form>
				</div>
			</section>
		</main>
	);
};

export default Login;
